import { useMutation } from '@apollo/client';
import { IdCardProcessResult } from '../../shared/types';
import { CITRIN_PROCESS_ID_CARD, ProcessIdCardRequest, ProcessIdCardResponse } from '..';

type CreateMutationFunction = (file?: any) => Promise<IdCardProcessResult>;
export const useProcessIDCardMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<ProcessIdCardResponse, ProcessIdCardRequest>(CITRIN_PROCESS_ID_CARD);

    const promiseMutation = async (file?: any) => {
        const result = await mutation({
            variables: { file },
        });
        return result.data.CITRIN_EXT_API_processIdCard;
    };
    return {
        mutation: promiseMutation,
        loading,
    };
};
